import React from 'react';
import { useScopedI18n } from '@locales/client';
import { BodyTextBoldPrimary } from '@/shared/ui/typography';

import { Image } from '@/shared/ui/image/Image';

import { NotFoundWrapper, NotFoundContent } from './styles';

export const BonusNotFound = () => {
  const t = useScopedI18n('bonus');

  return (
    <NotFoundWrapper>
      <NotFoundContent>
        <BodyTextBoldPrimary>{t('empty')}</BodyTextBoldPrimary>
        <Image
          alt="not found"
          src="/images/no-bonus-pic.png"
          width={240}
          height={220}
          styleForBox={{ margin: 'auto' }}
        />
      </NotFoundContent>
    </NotFoundWrapper>
  );
};
